import { createContext, useState, useEffect, useContext } from 'react'
import { calcGrowthDataset } from '../util/calcGrowthDataset'
import { newCalculator } from '../util/newCalculator'
export const CalcContext = createContext()

export const CalcContextProvider = ({ children }) => {
  const [mrr, setMrr] = useState(100000)
  const [mom, setMom] = useState(0.03)
  const [me, setMe] = useState(180)
  const [gm, setGm] = useState(0.85)
  const [cb, setCb] = useState(1000)
  const [growthDataSet, setGrowingDataSet] = useState([])
  const [newGrowthDataSet, setNewGrowthDataSet] = useState([])
  const [growthDataSetUpper, setGrowingDataSetUpper] = useState([])
  const [growthDataSetLower, setGrowingDataSetLower] = useState([])
  const [dataSet, setDataSet] = useState([])
  const [dataSetUpper, setDataSetUpper] = useState([])
  const [dataSetLower, setDataSetLower] = useState([])
  const [dataSetRunway, setDataSetRunway] = useState([])
  const [dataSetRunwayNew, setDataSetRunwayNew] = useState([])
  const [dataSetBase, setDataSetBase] = useState([])
  const [runwayWithout, setRunwayWithout] = useState(0)
  const [runwayWith, setRunwayWith] = useState(0)
  const [runwayWithNoMarketing, setRunwayWithNoMarketing] = useState(0)
  const [dataSetCapital, setDataSetCapital] = useState([])

  const monthCount = 2 * 12
  const share_of_ARR = 0.5
  // http://localhost:1234/?gm=0.85&cb=1000000&mom=0.03&mrr=100000&me=180000
  // https://fejron-calculator.netlify.app/?gm=0.85&cb=1000000&mom=0.03&mrr=100000&me=180000
  useEffect(() => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop)
    })
    const _gm = params.gm
    const _cb = params.cb
    const _me = params.me
    const _mom = params.mom
    const _mrr = params.mrr
    if (_gm) setGm(parseFloat(_gm))
    if (_cb) setCb(parseFloat(_cb))
    if (_me) setMe(parseFloat(_me))
    if (_mom) setMom(parseFloat(_mom))
    if (_mrr) setMrr(parseFloat(_mrr))
  }, [])

  useEffect(() => {
    setNewGrowthDataSet(
      newCalculator({ mrr: mrr, mom, me: me, gm, cb: cb }, monthCount)
    )
    setGrowingDataSet(
      calcGrowthDataset(
        { mrr: mrr, mom, me: me, gm, cb: cb * 1000 },
        monthCount,
        false,
        false
      )
    )

    // setDataSetRunway(
    //   calcGrowthDataset(
    //     { mrr: mrr, mom, me: me, gm, cb: cb * 1000 },
    //     monthCount,
    //     false,
    //     true
    //   )
    // )

    setDataSetRunwayNew(
      newCalculator({ mrr: mrr, mom, me: me, gm, cb: cb }, 2 * 12)
    )
  }, [mrr, mom, me, gm, cb])

  // Growth
  useEffect(() => {
    if (
      newGrowthDataSet &&
      newGrowthDataSet.companyFinancialsWithoutFejron &&
      newGrowthDataSet.companyFinancialsWithoutFejron.length > 0 &&
      newGrowthDataSet.companyFinancialsWithFejronExtraMarketing &&
      newGrowthDataSet.companyFinancialsWithFejronExtraMarketing.length > 0
    ) {
      setDataSet(
        newGrowthDataSet.companyFinancialsWithFejronExtraMarketing.map((a) => ({
          x: a.month,
          y: a.sales
        }))
      )
      setDataSetUpper(
        newGrowthDataSet.companyFinancialsWithFejronExtraMarketing.map((a) => ({
          x: a.month,
          y: a.sales * 1.05 ** (a.month / 12)
        }))
      )
      setDataSetLower(
        newGrowthDataSet.companyFinancialsWithFejronExtraMarketing.map((a) => ({
          x: a.month,
          y: a.sales * 0.95 ** (a.month / 12)
        }))
      )
      setDataSetBase(
        newGrowthDataSet.companyFinancialsWithoutFejron.map((a) => ({
          x: a.month,
          y: a.sales
        }))
      )
    }
  }, [newGrowthDataSet])

  // New runway
  useEffect(() => {
    if (
      dataSetRunwayNew &&
      dataSetRunwayNew.companyFinancialsWithoutFejron &&
      dataSetRunwayNew.companyFinancialsWithoutFejron.length > 0 &&
      dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing &&
      dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing.length > 0
    ) {
      // Runway without Fejron
      for (const [
        month,
        data
      ] of dataSetRunwayNew.companyFinancialsWithoutFejron.entries()) {
        if (data.company_runway === 'Last month') {
          setRunwayWithout(data.month)
          break
        }
        if (
          month ===
          dataSetRunwayNew.companyFinancialsWithoutFejron.length - 1
        ) {
          setRunwayWith('No need')
        }
      }

      // Runway with Fejron with extra marketing
      for (const [
        month,
        data
      ] of dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing.entries()) {
        if (data.company_runway === 'Last month') {
          setRunwayWith(data.month)
          break
        }
        if (
          month ===
          dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing.length - 1
        ) {
          setRunwayWith('No need')
        }
      }

      // Runway with Fejron without extra marketing
      for (const [
        month,
        data
      ] of dataSetRunwayNew.companyFinancialsWithoutExtraMarketing.entries()) {
        if (data.company_runway === 'Last month') {
          setRunwayWithNoMarketing(data.month)
          break
        }
        if (
          month ===
          dataSetRunwayNew.companyFinancialsWithoutExtraMarketing.length - 1
        ) {
          setRunwayWithNoMarketing('No need')
        }
      }
    }
  }, [dataSetRunwayNew])
  // Capital
  useEffect(() => {
    // setDataSetCapital(
    //   growthDataSet.map((a) => ({
    //     x: a.month,
    //     y: a.newTotalCssVolume
    //   }))
    // )
    if (
      dataSetRunwayNew &&
      dataSetRunwayNew.companyFinancialsWithoutFejron &&
      dataSetRunwayNew.companyFinancialsWithoutFejron.length > 0 &&
      dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing &&
      dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing.length > 0
    ) {
      setDataSetCapital(
        newGrowthDataSet.companyFinancialsWithFejronExtraMarketing.map((a) => ({
          x: a.month,
          y: Math.round(a.sales) * share_of_ARR * 12
        }))
      )
    }
  }, [dataSetRunwayNew])

  return (
    <CalcContext.Provider
      value={{
        mrr,
        setMrr,
        mom,
        setMom,
        me,
        setMe,
        gm,
        setGm,
        cb,
        setCb,
        dataSet,
        dataSetUpper,
        dataSetLower,
        dataSetBase,
        runwayWithout,
        runwayWithNoMarketing,
        runwayWith,
        dataSetCapital,
        dataSetRunway,
        dataSetRunwayNew,
        growthDataSetUpper,
        growthDataSetLower
      }}
    >
      {children}
    </CalcContext.Provider>
  )
}

export function useCalc() {
  const context = useContext(CalcContext)
  if (context === undefined) {
    throw new Error('Context must be used within a Provider')
  }
  return context
}

export default CalcContextProvider
